import type {IDynamicImport} from '@/common/scripts/types/utils';
import type {IYandexMap} from '@/components/yandex-map/types';
import {Utils} from '@/common/scripts/utils';

let centerMap: HTMLElement | null = null;

const initMap = (): void => {
    const ymaps = window.ymaps;

    if (ymaps) {
        ymaps.ready(() => {
            import(/* webpackChunkName: "yandex-map" */ '@/components/yandex-map')
                .then(({default: YandexMap}: IDynamicImport) => {
                    if (centerMap === null) {
                        return;
                    }

                    const yandexMap: IYandexMap = new YandexMap(ymaps);

                    yandexMap.init({
                        wrapper                : centerMap,
                        cluster                : false,
                        fullScreenControl      : false,
                        customFullScreenControl: false,
                        customZoomControl      : true,
                        disableMobileDrag      : true
                    });
                });
        });
    }
};

const lazyMapObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry: IntersectionObserverEntry) => {
        if (entry.isIntersecting) {
            const lazyEl = entry.target;

            initMap();

            lazyMapObserver.unobserve(lazyEl);
        }
    });
});

const initLazyMap = (): void => {
    if (centerMap) {
        lazyMapObserver.observe(centerMap);
    }
};

const initCenterMap = (mapWrapper: HTMLElement): void => {
    centerMap = mapWrapper;

    if ('IntersectionObserver' in window) {
        Utils.checkMap(initLazyMap);
    } else {
        Utils.checkMap(initMap);
    }
};

const posters = document.querySelectorAll('.j-poster');

posters?.forEach((poster: any) => {
    const posterCheckbox = poster.querySelector('.j-poster-input');
    const posterButton = poster.querySelector('.j-poster-button');

    const updateButtonState = (): void => {
        if (posterCheckbox?.checked) {
            posterButton?.classList.toggle('is-disabled');
        } else {
            posterButton?.classList.toggle('is-disabled');
        }
    };

    posterCheckbox?.addEventListener('change', () => {
        updateButtonState();
    });

    updateButtonState();
});

export default initCenterMap;
